import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-changes',
  templateUrl: './service-changes.component.html',
  styleUrls: ['./service-changes.component.scss']
})
export class ServiceChangesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
